export const FETCH_PASSBOOK_DATA = 'fasTag/passbook/FETCH_PASSBOOK_DATA';
export const SET_PASSBOOK_DATA = 'fasTag/passbook/SET_PASSBOOK_DATA';
